<template>
	<div class="page with-logo">
		<div class="logo-text">
            <div>
                <button @click="goBack" class="button back"/>
            </div>
        </div>
		<h1>Your promotion</h1>

		<CalendarPair
			class="when"
			:first-calendar-min="earliestPromotionStartDate"
			:first-calendar-max="latestPromotionStartDate"
			:second-calendar-max="latestPromotionEndDate"
			:minimum-between-starts="shortestPromotionWindow"
			:first-date="selectedStartDate"
			:second-date="selectedEndDate"
			@input="inputDates"
			@back="resetDates">
		</CalendarPair>

		<BundleList class="how-much"
			v-if="selectedStartDate && selectedEndDate"
			:bundles="config.bundles"
			:chosen-entity-count="this.basketEntities.length"
			@input="inputBundle">
		</BundleList>
	</div>
</template>

<script>
    import basketHolderMixin from '../../mixins/basketHolder.js'
    import BundleList from '../BundleList';
    import CalendarPair from '../CalendarPair';
    import 'v-calendar/lib/v-calendar.min.css';

    export default {
        components: {
            BundleList,
            CalendarPair,
        },
        props: [
            'config', 'basket'
        ],
        data() {
            return {
                selectedStartDate: null,
                selectedEndDate: null,
            }
        },

        mixins: [
            basketHolderMixin
        ],

        computed: {
            earliestPromotionStartDate() {
                return new Date(this.config.earliestPromotionIso)
            },
            latestPromotionStartDate() {
                // Clone to prevent mutating basket state
                let localEntities = [...this.basketEntities]
                let sortedEntities = localEntities.sort(this.sortEventsByEndDateAscending)

                if (sortedEntities.length === 0) {
                    return null
                }

                // N days before the earliest event's end date
                let latestPromotionStartDate = new Date(sortedEntities[0].endIso)
                latestPromotionStartDate.setDate(latestPromotionStartDate.getDate() - this.shortestPromotionWindow);
                return latestPromotionStartDate
            },
            latestPromotionEndDate() {
                // Clone to prevent mutating basket state
                let localEntities = [...this.basketEntities]
                let sortedEntities = localEntities.sort(this.sortEventsByEndDateAscending)

                if (sortedEntities.length === 0) {
                    return null
                }

                // Get the latest end date
                return new Date(sortedEntities[sortedEntities.length - 1].endIso)
            },
            shortestPromotionWindow() {
                return this.config.shortestPromotionWindow
            }
        },

        watch: {},

        methods: {
            inputDates(dates) {
                let [startDate, noLaterThanDate] = dates.map(this.makeDateUtc);

                this.selectedStartDate = startDate;
                this.selectedEndDate = noLaterThanDate;

                this.scrollToSelector('.how-much')
            },
            resetDates() {
                this.selectedStartDate = null;
                this.selectedEndDate = null;
            },
            /**
             * The v-date-picker component emits a date object with a time
             * of 00:00:00 in the user's current timezone. This date will be
             * converted to UTC when sent to the server. This is a problem
             * If the user's timezone is BST this results in an hour being
             * subtracted, yielding an incorrect start date a day earlier
             * than what the user clicked.
             * To work around this a new UTC date object is created from
             * the year, month, day portion of the v-date-picker date.
             * @param {Date} givenDate
             * @return {Date}
             */
            makeDateUtc(givenDate) {
                return new Date(
                    Date.UTC(
                        givenDate.getFullYear(),
                        givenDate.getMonth(),
                        givenDate.getDate(),
                        0,
                        0,
                        0
                    )
                );
            },
            inputBundle(bundle) {
                let newBasket = Object.assign({}, this.$route.params.basket, {
                    impressions: bundle.impressions,
                    startIso: this.selectedStartDate,
                    endIso: this.selectedEndDate,
                })
                let newParams = Object.assign({}, this.$route.params, {basket: JSON.stringify(newBasket)})

                this.$router.push({
                    name: 'bonus-buttons',
                    params: newParams
                })
            },
            sortEventsByEndDateAscending(a, b) {
                if (a.endIso < b.endIso) {
                    return -1
                } else if (a.endIso > b.endIso) {
                    return 1
                }
                return 0
            },
            scrollToSelector(selector) {
                let options = {
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                }

                setTimeout(() => this.$el.querySelector(selector).scrollIntoView(options), 300)
            },
        },
        mounted() {
            if (this.basket.startIso) {
                this.selectedStartDate = new Date(this.basket.startIso)
            }
            if (this.basket.endIso) {
                this.selectedEndDate = new Date(this.basket.endIso)
            }
        }
    }
</script>

<style lang="scss" scoped>
	.page {
		// Allow space for search <input>, calendars etc. to be scolled to the top, even when there is no content below them
		// XK: This serves as a partial fix for the CalendarPair scroll glitch where <transition> is briefly empty
		min-height: 2100px;
	}

	.calendar {

		.c-day-content {

			// XK: "fix" for calendar selected day BG not inline issue
			// Removing Roboto import also fixes...
			div {
				height: 100%;
				transform: translateY(28%);
			}
		}
	}
</style>

